import React from 'react';
import { m } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
export function AboutAuthor() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-21" data-mp="2hf4lkrab19s1">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-22" data-mp="2m9h3gww4ud1o">
        <div className="mb-6 text-center" data-id="element-23" data-mp="2q9ri0xxzqbs5">
          <SectionTag icon="🏐" data-id="element-24" data-mp="2q8hkc9v1v5m1">Acerca de VOLEY-PRO 360</SectionTag>
        </div>

        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-gris-claro bg-bg-secondary p-8 text-center shadow-card sm:p-10" data-id="element-25" data-mp="1tka8u8zsu7lp">
          <QuoteIcon size={28} className="mx-auto text-azul" data-id="element-26" data-mp="27jjjkt58k9ia" />
          <p className="mt-4 text-lg italic leading-relaxed text-gris-oscuro sm:text-xl" data-id="element-27" data-mp="3dzdjxt5qz53u">
            "VOLEY-PRO 360 nace de la experiencia de entrenadores con más de una década trabajando en
            voleibol formativo. Conocemos los desafíos de preparar sesiones, corregir errores técnicos,
            organizar equipos de diferentes niveles y planificar una temporada completa."
          </p>
          <div className="mx-auto mt-6 max-w-xl border-t border-gris-claro pt-4" data-id="element-28" data-mp="20t5gtledg53m">
            <p className="font-heading text-base font-semibold text-azul-dark" data-id="element-29" data-mp="20v8fettlb6jy">El Equipo de VOLEY-PRO 360</p>
            <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-30" data-mp="1vweyssj0azfk">
              Por eso reunimos herramientas prácticas que puedes adaptar a las necesidades de tu equipo,
              independientemente del país donde entrenes. Formados en categorías formativas, en el
              vestuario ruidoso y en la reunión de padres difícil — todo lo que encontrarás en VOLEY-PRO 360
              viene de ahí. No de la teoría. Del entrenamiento real.
            </p>
          </div>
        </m.div>
      </div>
    </section>;
}